import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import useAuthStore from '../store/authStore';

const PrivateRoute = () => {
  const { user, token } = useAuthStore();
  const location = useLocation();

  // localStorage에서 직접 확인
  const storedToken = localStorage.getItem('token');
  const authStorage = localStorage.getItem('auth-storage');
  
  console.log('PrivateRoute Check:', {
    user: !!user,
    token: !!token,
    storedToken: !!storedToken,
    authStorage: !!authStorage,
    location: location.pathname
  });
  
  // auth-storage 파싱 시도
  let hasValidAuth = false;
  if (authStorage) {
    try {
      const authData = JSON.parse(authStorage);
      if (authData.state?.token && authData.state?.user) {
        hasValidAuth = true;
      }
      console.log('Auth Storage Data:', {
        hasToken: !!authData.state?.token,
        hasUser: !!authData.state?.user
      });
    } catch (e) {
      console.error('Auth Storage Parse Error:', e);
    }
  }
  
  // Zustand store나 localStorage 중 하나라도 유효한 인증이 있으면 통과
  if ((user && token) || storedToken || hasValidAuth) {
    console.log('PrivateRoute: Allowing access');
    return <Outlet />;
  }

  // 인증 정보가 전혀 없을 때만 로그인으로
  console.log('PrivateRoute: Redirecting to login');
  return <Navigate to="/login" state={{ from: location.pathname }} replace />;
};

export default PrivateRoute;